// Englische Fassung von ../de/nav.ts. Navigations-Einträge stehen in Title Case
// („Image Library"), Fließtext und Hinweise in Satzform — dieselbe Aufteilung
// wie in gängigen Office-Oberflächen.
import type { NavKatalog } from "../de/nav";

export const nav: NavKatalog = {
  uebersicht: "Overview",
  gruppeAlltag: "Everyday",
  aufgaben: "Tasks",
  mail: "Mail",
  kalender: "Calendar",
  notizen: "Notes",
  dokumente: "Documents",
  tabellen: "Tables",
  gruppeProjekte: "Projects",
  projekte: "Projects",
  gruppeStudio: "Studio",
  emailAutomatisierungen: "Email Automations",
  emailAutomatisierungenKachel: "Email Autom.",
  claimFreigaben: "Claim Approvals",
  bildBibliothek: "Image Library",
  videoStudio: "Video Studio",
  videoStudioKachel: "Video",
  blog: "Blog",
  fragebogen: "Questionnaires",
};
